import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

[hidden] {
  display: none !important;
}

form {
  display: flex;
}

form button.xs-btn {
  height: var(--input-height);
  min-width: var(--input-height);
  margin-left: 8px;
  border-radius: 50%;
}

input {
  border-radius: 50px;
}

textarea.input-control {
  min-height: 0;
  height: auto;
}
`;
export default styles;
